module.exports = __webpack_public_path__ + "static/img/image_support_video_cover_04.e90471a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_video_cover_04.png
// module id = 6JrI
// module chunks = 10